import React, { useEffect, useRef } from 'react';

interface AudioPlayerProps {
  stream: MediaStream | null;
}

const AudioPlayer: React.FC<AudioPlayerProps> = ({ stream }) => {
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    if (audioRef.current && stream) {
      audioRef.current.srcObject = stream;
      audioRef.current.play().catch(console.error);
    }
  }, [stream]);

  return <audio ref={audioRef} autoPlay playsInline className="w-full mb-4" />;
};

export default AudioPlayer;
